// ============================================================================
// LandingFooter — a calm closing footer. Brand mark + tagline, the same in-page
// + login links as the nav, the language toggle, and a copyright line. Stacks
// on mobile, spreads on sm+.
// ============================================================================
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LanguageToggle } from "../../i18n/LanguageToggle";
import { CLIENT_LOGIN_PATH } from "../../client/routes";

export function LandingFooter() {
  const { t } = useTranslation("landing");
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-line bg-surface">
      <div className="mx-auto max-w-shell px-gutter py-12">
        <div className="flex flex-col gap-8 sm:flex-row sm:items-start sm:justify-between">
          <div className="max-w-sm">
            <Link to="/" className="inline-flex items-center gap-2.5">
              <span className="grid h-9 w-9 place-items-center rounded-md bg-grad-coral shadow-volt">
                <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" aria-hidden>
                  <path
                    d="M3 13h4l2-6 3 11 2.6-8L18 13h3"
                    stroke="#fff"
                    strokeWidth="2.4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
              <span className="font-display text-lg font-extrabold tracking-tightest text-body">
                {t("app.name", { ns: "common" })}
              </span>
            </Link>
            <p className="mt-3 text-sm text-body-soft">{t("footer.tagline")}</p>
          </div>

          <div className="flex flex-col gap-6 sm:items-end">
            <nav className="flex flex-wrap items-center gap-x-6 gap-y-3 sm:justify-end">
              <a href="#features" className="font-display text-sm font-bold text-body-soft transition-colors hover:text-coral">
                {t("footer.links.features")}
              </a>
              <a href="#portal" className="font-display text-sm font-bold text-body-soft transition-colors hover:text-coral">
                {t("footer.links.portal")}
              </a>
              <a href="#why" className="font-display text-sm font-bold text-body-soft transition-colors hover:text-coral">
                {t("footer.links.why")}
              </a>
              <Link to="/login" className="font-display text-sm font-bold text-body-soft transition-colors hover:text-coral">
                {t("footer.links.signIn")}
              </Link>
              <Link to={CLIENT_LOGIN_PATH} className="font-display text-sm font-bold text-body-soft transition-colors hover:text-coral">
                {t("footer.links.clientSignIn")}
              </Link>
            </nav>
            <LanguageToggle />
          </div>
        </div>

        <div className="mt-10 border-t border-line-soft pt-6 text-center text-xs text-body-faint sm:text-left">
          © {year} {t("app.name", { ns: "common" })}. {t("footer.rights")}
        </div>
      </div>
    </footer>
  );
}
